<template>
  <div class="page-title">
    {{ title }}
    <div class="svg-icon svg-baseline pointer" @click="clicked">
      <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48">
        <path
          d="M43.3 28.2v.1q-1.6 7-7 11.4Q31 44 24 44q-3.8 0-7.4-1.4-3.5-1.5-6.3-4.1l-3.4 3.3q-.5.5-1.1.5-.7 0-1.2-.5T4 40.7V29q0-.7.5-1.2t1.2-.5h11.6q.7 0 1.2.5T19 29q0 .7-.5 1.2L15 33.7q1.9 1.8 4.2 2.7 2.4 1 4.9 1 3.5 0 6.5-1.8 3-1.7 4.9-4.6l1.3-3q.2-.7.8-.7h5q.4 0 .6.3.2.2.2.6zM44 7.3V19q0 .7-.5 1.2t-1.2.5H30.7q-.7 0-1.2-.5T29 19q0-.7.5-1.2l3.6-3.6q-3.9-3.5-9.1-3.5-3.5 0-6.5 1.7T12.6 17l-1.3 3q-.2.7-.8.7H5.3q-.3 0-.6-.3-.2-.2-.2-.6v-.1q1.7-7 7-11.4Q16.8 4 24 4q3.8 0 7.4 1.4Q35 7 37.8 9.5l3.4-3.3q.5-.5 1.1-.5.7 0 1.2.5t.5 1.1z"
          fill="#8da3ac"
        />
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      String,
      required: true
    },
    callback: {
      Object,
      required: true
    }
  },

  methods: {
    clicked() {
      this.callback()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/General/TitleBlock.vue